module.exports = require('./lib');



/*****************
 ** WEBPACK FOOTER
 ** ./~/jsan/index.js
 ** module id = 452
 ** module chunks = 0
 **/